import { Injectable } from '@angular/core'
import { BaseProviderStatus, BaseShippingProviderService, ProviderStatusEntry } from '../shared/base-shipping-provider.service'

export interface AramexSettings {
  enabled: boolean
  accountNumber: string
  accountPin: string
  accountEntity: string
  accountCountryCode: string
  username: string
  password: string
  originCountryCode: string
  originCityName: string
  originPostalCode: string
  originAddressLine: string
  originPhone: string
}

export interface AramexSettingsStatus extends BaseProviderStatus {
  accountNumberMasked?: string
  accountEntity?: string
  accountCountryCode?: string
  originCountryCode?: string
  originCityName?: string
  originPostalCode?: string
  originAddressLine?: string
  originPhone?: string
}

@Injectable({
  providedIn: 'root'
})
export class AramexSettingsService extends BaseShippingProviderService<AramexSettings, AramexSettingsStatus> {
  protected readonly providerKey = 'aramex'
  protected readonly providerLabel = 'Aramex'

  protected mapStatus(entry: ProviderStatusEntry): AramexSettingsStatus {
    return {
      connected: entry.connected,
      enabled: entry.enabled,
      accountNumberMasked: entry.accountNumberMasked,
      accountEntity: entry.settings?.['accountEntity'] as string | undefined,
      accountCountryCode: entry.settings?.['accountCountryCode'] as string | undefined,
      originCountryCode: entry.originAddress?.countryCode,
      originCityName: entry.originAddress?.cityName,
      originPostalCode: entry.originAddress?.postalCode,
      originAddressLine: entry.originAddress?.addressLine,
      originPhone: entry.originAddress?.phone
    }
  }

  protected buildSaveBody(projectId: string, settings: AramexSettings): Record<string, unknown> {
    return {
      projectId,
      enabled: settings.enabled,
      accountNumber: settings.accountNumber,
      accountPin: settings.accountPin,
      accountEntity: settings.accountEntity,
      accountCountryCode: settings.accountCountryCode,
      username: settings.username,
      password: settings.password,
      originCountryCode: settings.originCountryCode,
      originCityName: settings.originCityName,
      originPostalCode: settings.originPostalCode,
      originAddressLine: settings.originAddressLine,
      originPhone: settings.originPhone,
    }
  }
}
